const eventServices = [
  {
    id: 'lumina',
    title: 'Lumina Portrait Studios',
    category: 'Photography',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDuECgVf7oTi6W5qG2yVPdaiURHldt4o1JCqiwhZHmQDJdEZcVR-VTwhGZV4AOC4-5aruXFdIohbbwtMFbH8LqzIH7wWkngG9Plq6201Cty2dG4JqaqIyusvbxc6HQiGPpjLEflGPmPXjVnZl-qmc6y2Wug8_n9OT874gr3P_CiwU6KPsWr1cC7ZB9m5f2U2GCi6Zf2uo4UhcMOBCMgZJDVm8ljk9suQEKAkPe3U0PXpWJGWbljngGWjPaZYVpUl9kRuEJaxSSn7T-p',
    rating: 4.9,
    price: '₹85,000',
    pricePeriod: '/ day',
    description: 'Cinematic wedding coverage and pre-wedding shoots with a team of expert professionals.'
  },
  {
    id: 'aura',
    title: 'Aura Events & Decor',
    category: 'Decorators',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt',
    rating: 4.8,
    price: '₹1,75,000',
    pricePeriod: '/ event',
    description: 'Bespoke floral setups, mood lighting, and themed stage environments for luxury events.'
  },
  {
    id: 'golden-knot',
    title: 'Golden Knot Planners',
    category: 'Planners',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuB-zDqJfWD5Y9LKK49gXMOyXrwT9ufZry_2RG9X09e3ddJ-o0sZ8n-BABuAKSQ_fvD4Y79j6CmLgzNzoZ9v6p8Mq7QvkYk8z4aXhqEbBDJC9rNEV6qVLfxMClPLPKqKanGwJcxnzXs8agoIMgxd2_snTTgGo05Ch11YJNW8EPAya4SbOMubVbbOLChiLQ8pAY-7LPHsW8l-YA_vG2ZmiGNFB3fOikK9YuYrTvE8bOku-khz2I2Ft19fWUmsJeudOnmx8DicW7hlreHZ',
    rating: 5.0,
    price: '₹3,50,000',
    pricePeriod: '/ pkg',
    description: 'Full-service planning from venue selection to guest coordination and catering.'
  }
];

export default eventServices;
